import Home from './views/Home.vue'
// import homePage from './views/homePage.vue'

let routes = [{
        path: '/index',
        name: '首页',
        iconCls: 'fa fa-home fa-1x',
        component: Home,
        leaf: true,
        children: [{
            path: '/index',
            name: '首页',
            component: () => import('@/views/home/index')
        }]
    },
    {
        path: '/homePageCont',
        name: '商户首页',
        component: Home,
        iconCls: 'fa fa-archive',
        children: [{
            path: '/homePageCont',
            name: '商户首页',
            component: () => import('@/views/userIndex/homePageCont'),
            meta: {
                title: '商户首页'
            }
        }, ]
    },
    //用户管理
    {
        path: '/userManagement',
        name: '用户',
        iconCls: 'fa fa-user',
        component: Home,
        children: [{
                path: '/user',
                component: () => import('@/views/userAdmin/user'),
                name: '用户管理',
                meta: {
                    title: '用户管理'
                }
            },
            {
                path: '/memberManagement',
                component: () => import('@/views/userAdmin/memberManagement'),
                name: '成员列表',
                hidden: true,
            },
            {
                path: '/userDetails',
                component: () => import('@/views/userAdmin/userDetails'),
                name: '认证详情',
                hidden: true
            },
            {
                path: '/personal',
                component: () => import('@/views/userAdmin/personal'),
                name: '个人认证',
            },
            // {
            //     path: '/enterprise',
            //     component: () => import('@/views/userAdmin/enterprise'),
            //     name: '企业认证',
            // },
            {
                path: '/newEnterprise',
                component: () => import('@/views/userAdmin/newEnterprise'),
                name: '企业认证',
            },
            {
                path: '/approveSetting',
                component: () => import('@/views/userAdmin/approveSetting'),
                name: '认证设置',
            },
            {
                path: '/userLogo',
                component: () => import('@/views/userAdmin/userLogo'),
                name: '日志'
            },
        ]
    },
    // 订单管理
    {
        path: '/orderManagement',
        name: '订单',
        iconCls: 'fa fa-shopping-cart',
        component: Home,
        children: [{
                path: '/survey',
                name: 'survey',
                component: () => import('@/views/orderManagement/survey'),
                meta: {
                    title: '订单概况'
                }
            },
            {
                path: '/surveyList',
                name: '应用订单详情',
                component: () => import('@/views/orderManagement/surveyList'),
                meta: {
                    title: '应用订单详情'
                },
                hidden: true
            },
            {
                path: '/statistical',
                name: 'statistical',
                component: () => import('@/views/orderManagement/statistical'),
                meta: {
                    title: '订单统计'
                }
            },
            {
                path: '/order',
                component: () => import('@/views/orderManagement/order'),
                name: '订单管理'
            },
            {
                path: '/orderDetils',
                component: () => import('@/views/orderManagement/orderDetils'),
                name: '订单详情',
                hidden: true
            },
            {
                path: '/orderDetils2',
                component: () => import('@/views/orderManagement/orderDetils2'),
                name: '订单详情退款',
                hidden: true //显示还是不显示
            }
        ]
    },
    // 商品管理
    {
        path: '/goodsManagement',
        name: '商品管理',
        component: Home,
        iconCls: 'fa fa-archive',
        children: [{
                path: '/releaseGoods',
                name: '发布商品',
                component: () => import('@/views/goodsManagement/releaseGoods'),
                meta: {
                    title: '发布商品'
                }
            },
            {
                path: '/classManage',
                name: '分类管理',
                component: () => import('@/views/goodsManagement/classManage'),
                meta: {
                    title: '分类管理'
                }
            },
            {
                path: '/goodsList',
                name: '商品管理',
                component: () => import('@/views/goodsManagement/goodsList'),
                meta: {
                    title: '商品管理'
                }
            },
        ]
    },
    // 子系统管理
    {
        path: '/SetUp',
        name: '子系统管理',
        component: Home,
        iconCls: 'fa fa-archive',
        children: [{
                path: '/addChild',
                name: '子系统列表',
                component: () => import('@/views/SetUp/addChild'),
                meta: {
                    title: '新增子系统'
                }
            },
            {
                path: '/SetList',
                name: '子系统列表',
                component: () => import('@/views/SetUp/SetList'),
                meta: {
                    title: '子系统列表'
                }
            },
            {
                path: '/versionManagement',
                name: '版本管理',
                hidden: true,
                component: () => import('@/views/SetUp/versionManagement'),
                meta: {
                    title: '版本管理'
                }
            },
            {
                path: '/MerchantMenu',
                name: '运营菜单',
                component: () => import('@/views/SetUp/MerchantMenu'),
                meta: {
                    title: '运营菜单'
                }
            },
            {
                path: '/businessMenu',
                name: '商户菜单',
                component: () => import('@/views/SetUp/BusinessMenu'),
                meta: {
                    title: '商户菜单'
                }
            },
            {
                path: '/businessVersionMenu',
                name: '商户版本',
                component: () => import('@/views/SetUp/BusinessVersionMenu'),
                meta: {
                    title: '商户版本'
                }
            },
        ]
    },
    // //代理商管理
    {
        path: '/agent_Management',
        name: '代理商管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/agentManagement',
                component: () => import('@/views/agent_Management/agentManagement'),
                name: '代理商管理',
            },
            {
                path: '/agentDetils',
                hidden: true,
                component: () => import('@/views/agent_Management/agentDetils'),
                name: '代理商详情',
            },
            {
                path: '/Customer',
                hidden: true,
                component: () => import('@/views/agent_Management/Customer'),
                name: '客户列表',
            },
            {
                path: '/CustomerDeils',
                hidden: true,
                component: () => import('@/views/agent_Management/CustomerDeils'),
                name: '客户详情',
            },
            {
                path: '/CommissionList',
                hidden: true,
                component: () => import('@/views/agent_Management/CommissionList'),
                name: '佣金明细',
            },
            {
                path: '/monthlyList',
                hidden: true,
                component: () => import('@/views/agent_Management/monthlyList'),
                name: '月度佣金详情',
            },
            {
                path: '/quarterList',
                hidden: true,
                component: () => import('@/views/agent_Management/quarterList'),
                name: '季度佣金详情',
            },
            {
                path: '/CommissionDetils',
                hidden: true,
                component: () => import('@/views/agent_Management/CommissionDetils'),
                name: '佣金提取详情',
            },
            {
                path: '/OrderList',
                hidden: true,
                component: () => import('@/views/agent_Management/OrderList'),
                name: '代理商订单列表',
            },
            {
                path: '/OrderDs_daili',
                hidden: true,
                component: () => import('@/views/agent_Management/OrderDs_daili'),
                name: '代理商订单详情',
            },
        ]
    },
    //服务合作伙伴
    {
        path: '/IndustryPartners',
        name: '服务合作伙伴',
        iconCls: '',
        component: Home,
        children: [{
                path: '/industryPartnersUserList',
                component: () => import('@/views/IndustryPartners/userList'),
                name: '服务合作伙伴列表',
            },
            {
                path: '/industryPartnersUserDetails',
                hidden: true,
                component: () => import('@/views/IndustryPartners/userDetails'),
                name: '服务合作伙伴详情',
            },
            {
                path: '/industryPartnersOrderList',
                component: () => import('@/views/IndustryPartners/orderList'),
                name: '接单列表',
            },
            {
                path: '/industryPartnersOrderDetails',
                hidden: true,
                component: () => import('@/views/IndustryPartners/orderDetails'),
                name: '接单列表详情',
            },
            {
                path: '/industryPartnersBusinessOpportunityList',
                component: () => import('@/views/IndustryPartners/businessOpportunityList'),
                name: '商机列表',
            },
            {
                path: '/industryPartnersBusinessOpportunityAdd',
                hidden: true,
                component: () => import('@/views/IndustryPartners/businessOpportunityAdd'),
                name: '发布商机',
            },
            {
                path: '/industryPartnersBusinessOpportunityDetails',
                hidden: true,
                component: () => import('@/views/IndustryPartners/businessOpportunityDetails'),
                name: '商机详情',
            }
        ]
    },
    //服务商商管理
    {
        path: '/supplier_index',
        name: '服务商管理',
        component: Home,
        children: [{
                path: '/supplier',
                name: '服务商管理',
                component: () => import('@/views/goodsManagement/supplier'),
                meta: {
                    title: '服务商管理'
                }
            },
            {
                path: '/serviceProviderDetils',
                hidden: true,
                name: '新增服务商',
                component: () => import('@/views/goodsManagement/serviceProviderDetils'),
                meta: {
                    title: '新增服务商'
                }
            },
            {
                path: '/lookProvide',
                hidden: true,
                name: '服务商详情',
                component: () => import('@/views/goodsManagement/lookProvide'),
                meta: {
                    title: '服务商详情'
                }
            },
        ]
    },
    //服务商管理
    // {
    //     path: '/serviceProvider_index',
    //     name: '服务商管理',
    //     component: Home,
    //     children: [
    //         {
    //             path: '/serviceProviderList',
    //             name: '服务商管理',
    //             component: () => import ('@/views/serviceProvider_index/serviceProviderList'),
    //             meta: { title: '服务商管理' }
    //         },
    //         {
    //             path: '/serviceProviderDetils',
    //             hidden: true,
    //             name: '新增服务商',
    //             component: () => import ('@/views/serviceProvider_index/serviceProviderDetils'),
    //             meta: { title: '新增服务商' }
    //         },
    //         {
    //             path: '/lookProvide',
    //             hidden: true,
    //             name: '服务商详情',
    //             component: () => import ('@/views/serviceProvider_index/lookProvide'),
    //             meta: { title: '服务商详情' }
    //         }
    //     ]
    // },
    //代理商管理
    {
        path: '/demandManagement',
        name: '代理商',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [
            // {
            //     path: '/demandManagement',
            //     component: () =>
            //         import ('@/views/demandManagement/demandList'),
            //     name: '代理商管理'
            // },
            // {
            //   path: '/demandDetalis',
            //   component: () => import('@/views/demandManagement/demandDetalis'),
            //   name: '管理详情',
            //   meta: {title: '管理详情'}
            // }
        ]
    },
    // 需求管理
    {
        path: '/demandList_index',
        name: '需求管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/demandList',
                component: () => import('@/views/demandManagement/demandList'),
                name: '需求管理'
            },
            {
                path: '/demandDetalis',
                hidden: true,
                component: () => import('@/views/demandManagement/demandDetalis'),
                name: '管理详情',

            }
        ]
    },
    // 信息管理
    {
        path: '/informationList_index',
        name: '信息管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/informationList',
                component: () => import('@/views/information/informationList'),
                name: '信息管理'
            },

        ]
    },
    // 权限管理
    {
        path: '/setings/AuserManagement_index',
        name: '权限',
        component: Home,
        iconCls: 'el-icon-setting',
        children: [{
                path: '/setings/AuserManagement',
                name: '用户管理',
                hidden: true,
                component: () => import('@/views/authorityManagement/AuserManagement')
            },
            {
                path: '/setings/roleManagement',
                name: '角色管理',
                hidden: true,
                component: () => import('@/views/authorityManagement/roleManagement')
            }
        ]
    },
    // 日志
    {
        path: '/setings/logJournal_index',
        name: '日志',
        component: Home,
        iconCls: 'el-icon-setting',
        children: [{
                path: '/setings/logJournal',
                name: '登陆日志',
                hidden: true,
                component: () => import('@/views/authorityManagement/logJournal')
            },
            {
                path: '/setings/operationJournal',
                name: '操作日志',
                component: () => import('@/views/authorityManagement/operationJournal')
            }
        ]
    },
    // 财务管理
    {
        path: '/financeAdmin',
        name: '财务管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/recharge',
                component: () => import('@/views/financeAdmin/recharge'),
                name: '线下充值'
            },
            // {
            //     path: '/cash',
            //     component: () => import ('@/views/financeAdmin/cash'),
            //     name: '线下提现',
            // },
            // {
            //     path: '/invoice',
            //     component: () => import ('@/views/financeAdmin/invoice'),
            //     name: '发票管理',
            // },
            // {
            //     path: '/invoiceDetails',
            //     hidden: true,
            //     component: () => import ('@/views/financeAdmin/invoiceDetails'),
            //     name: '发票管理详情',
            // },
        ]
    },


    //     path: '/workOrder_index',
    //     name: '工单管理',
    //     iconCls: 'fa fa-sitemap',
    //     component: Home,
    //     children:[
    //         {
    //             path: '/workOrder',
    //             component: () => import ('@/views/workOrder_index/workOrder'),
    //             name: '工单管理列表',
    //         },
    //         {
    //             path: '/workDetails',
    //             hidden: true,
    //             component: () => import ('@/views/workOrder_index/workDetails'),
    //             name: '工单管理详情',
    //         },
    //     ]
    // },
    //banner管理
    {
        path: '/banner_index',
        name: 'banner管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/bannerList',
                component: () => import('@/views/banner_index/bannerList'),
                name: '大banner管理',
            },
            {
                path: '/bannerList2',
                component: () => import('@/views/banner_index/bannerList2'),
                name: '小banner管理',
            },
            {
                path: '/bannerList3',
                component: () => import('@/views/banner_index/bannerList3'),
                name: '首页banner管理',
            },
        ]
    },
    // 活动中心
    {
        path: '/activityArea_index',
        name: '活动中心',
        iconCls: '',
        component: Home,
        children: [{
                path: '/adminiStration',
                component: () => import('@/views/activityArea_index/adminiStration'),
                name: '活动管理',
            },
            {
                path: '/recomMend',
                component: () => import('@/views/activityArea_index/recomMend'),
                name: '活动推荐',
            },
            {
                path: '/addActive',
                hidden: true,
                component: () => import('@/views/activityArea_index/addActive'),
                name: '发布活动',
            },
        ]
    },

    // 新闻管理
    // {
    //     path: '/news_index',
    //     name: '新闻管理',
    //     iconCls: '',
    //     component: Home,
    //     children: [
    //     {
    //             path: '/newsList',
    //             component: () =>
    //                 import ('@/views/news_index/newsLists'),
    //             name: '新闻列表',
    //         },
    //         {
    //             path: '/addnews',
    //             component: () =>
    //                 import ('@/views/news_index/addnews'),
    //             name: '新增新闻',
    //         },
    //         {
    //             path: '/editnews',
    //             component: () =>
    //                 import ('@/views/news_index/editnews'),
    //             name: '新闻编辑',
    //             hidden: true
    //         }
    //     ]
    // },
    //公告管理
    {
        path: '/notice_index',
        name: '公告管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
            path: '/noticeList',
            component: () =>
                import('@/views/notice_index/noticeList'),
            name: '公告管理',
        }, ]
    },
    // 邀请码管理
    {
        path: '/inviteCode_index',
        name: '邀请码管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
            path: '/inviteCodeList',
            component: () =>
                import('@/views/inviteCode_index/inviteCodeList'),
            name: '邀请码管理',
        }, {
            path: '/inviteCodeDetail',
            component: () =>
                import('@/views/inviteCode_index/inviteCodeDetail'),
            name: '邀请码详情',
            hidden: true
        }, {
            path: '/inviteCodeDetail1',
            component: () =>
                import('@/views/inviteCode_index/inviteCodeDetail1'),
            name: '体验码详情',
            hidden: true
        }, ]
    },
    // 友情管理
    {
        path: '/link_index',
        name: '友情链接管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
            path: '/linkList',
            component: () =>
                import('@/views/link_index/linkList'),
            name: '友情链接',
        }, ]
    },
    //优惠券
    {
        path: '/coupon_index',
        name: '优惠券管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/couponList',
                component: () => import('@/views/coupon_index/couponList'),
                name: '优惠券管理',
            },
            {
                path: '/addCoupon',
                component: () => import('@/views/coupon_index/addCoupon'),
                hidden: true,
                name: '发布优惠券',
            },
            {
                path: '/ruleCoupon',
                hidden: true,
                component: () => import('@/views/coupon_index/ruleCoupon'),
                name: '规则说明',
            },
        ]
    },
    // 发票管理
    {
        path: '/invoice_management',
        name: '发票管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/invoiceList',
                component: () => import('@/views/invoice/invoiceList'),
                name: '发票列表',
            },{
                path: '/invoiceVerifyList',
                component: () => import('@/views/invoice/invoiceVerifyList'),
                name: '发票审核列表',
            },
            {
                path: '/invoiceSetting',
                component: () => import('@/views/invoice/invoiceSetting'),
                name: '发票设置',
            },
            {
                path: '/invoiceVerify',
                component: () => import('@/views/invoice/invoiceVerify'),
                hidden: true,
                name: '发票详情',
            }
        ]
    },
    // {
    //     path: '/outbreak_index',
    //     name: '疫情管理',
    //     iconCls: 'fa fa-sitemap',
    //     component: Home,
    //     children: [
    //         {
    //             path: '/outbreak',
    //             component: () =>
    //                 import('@/views/outbreak/outbreak.vue'),
    //             name: '疫情管理'
    //         },

    //     ]
    // },

    // //客户中心
    // {
    //     path: '/customer_Center',
    //     name: '客户中心',
    //     iconCls: 'fa fa-sitemap',
    //     component: Home,
    //     children:[
    //         {
    //             path: '/customerCenter',
    //             component: () => import ('@/views/customer_Center/customerCenter'),
    //             name: '客户中心',
    //         },
    //     ]
    // },


    // /-------------------------------------------------轻云平台2.0管理---------------------------------------/
    //新闻管理
    {
        path: '/jvtdPage',
        name: '首页',
        iconCls: 'fa fa-home fa-1x',
        component: Home,
        leaf: true,
        children: [{
            path: '/jvtdPage',
            name: '首页',
            component: () =>
                import('@/jvtdPage/jvtdHome')
        }]
    },
    {
        path: '/leaveWord',
        name: '信息咨询',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/leaveWordList',
                component: () => import('@/jvtdPage/leaveWord/leaveWordList'),
                name: '信息咨询' 
            },

        ]
    },
    {
        path: '/newsManage_index',
        name: '新闻管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/newsList',
                component: () => import('@/jvtdPage/newsManage_index/newsList'),
                name: '新闻列表',
            },
            {
                path: '/addnews',
                component: () => import('@/jvtdPage/newsManage_index/newsAdd'),
                name: '新增新闻',
            },
            {
                path: '/newsType',
                name: '新闻分类',
                component: () => import('@/jvtdPage/newsManage_index/newsType'),
                meta: {
                    title: '新闻分类'
                }
            },
        ]
    },
    {
        path: '/template_index',
        name: '页面管理',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/template',
                component: () => import('@/jvtdPage/template/index.vue'),
                name: '页面管理',
            },
            {
                path: '/about',
                hidden: true,
                component: () => import('@/jvtdPage/template/about.vue'),
                name: '关于聚通达',
            },
            {
                path: '/template-1',
                component: () => import('@/jvtdPage/template/template-1.vue'),
                hidden: true,
                name: '模版一',
            },
            {
                path: '/template-2',
                component: () => import('@/jvtdPage/template/template-2.vue'),
                hidden: true,
                name: '模版二',
            },
            {
                path: '/template-3',
                component: () => import('@/jvtdPage/template/template-3.vue'),
                hidden: true,
                name: '模版三',
            },
            {
                path: '/template-4',
                component: () => import('@/jvtdPage/template/template-4.vue'),
                hidden: true,
                name: '模版四',
            },
            {
                path: '/template-5',
                component: () => import('@/jvtdPage/template/template-5.vue'),
                hidden: true,
                name: '模版五️',
            },
            {
                path: '/template-6',
                component: () => import('@/jvtdPage/template/template-6.vue'),
                hidden: true,
                name: '模版六️',
            },
            {
                path: '/template-10',
                component: () => import('@/jvtdPage/template/template-10.vue'),
                hidden: true,
                name: '模版十️',
            }
        ]
    },
    {
        path: '/zhyx_index',
        name: 'zhyx',
        iconCls: 'fa fa-sitemap',
        component: Home,
        children: [{
                path: '/zhyx',
                component: () => import('@/jvtdPage/zhyx/index.vue'),
                name: 'zhyxIndex'
            },
            {
                path: '/updataZhyx',
                hidden: true,
                component: () => import('@/jvtdPage/zhyx/updataZhyx.vue'),
                name: '编辑案例'
            },
        ]
    }
]
export default routes;


// WEBPACK FOOTER //
// ./src/routes.js